import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';

import { CONSENT_STATUS } from '../../../constants/whatsapp-contacts';
import { colors } from '../theme';

const useStyles = makeStyles(() => ({
  ok: { backgroundColor: colors.okBg, color: colors.okText },
  warn: { backgroundColor: colors.warnBg, color: colors.warnText },
  error: { backgroundColor: '#ffebee', color: '#b71c1c' },
  idle: { backgroundColor: colors.mutedBg, color: colors.mutedText },
}));

// Значок статуса согласия: «Подтверждён», «Ждём ответа», «Отказался», «Не запрашивали».
function ConsentChip({ status, onClick, size = 'small' }) {
  const classes = useStyles();
  const info = CONSENT_STATUS[status] || CONSENT_STATUS.none;
  return (
    <Chip
      size={size}
      className={classes[info.kind]}
      label={info.label}
      clickable={Boolean(onClick)}
      onClick={onClick}
    />
  );
}

export default ConsentChip;
